import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function ActionButtons(props) {
  const { applicationId, handleFormSave } = props;

  return (
    <Grid container justifyContent="center" id="buttonContainer" tabIndex="0">
      <Grid item>
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={() => handleFormSave(false, true)}
        >
          Save
        </Button>
      </Grid>
      {applicationId !== "new" && (
        <Grid item>
          <Button
            variant="contained"
            startIcon={<ArrowForwardIcon />}
            onClick={() => handleFormSave(true, true)}
          >
            Save & Next
          </Button>
        </Grid>
      )}
      <Grid item>
        <Button variant="contained" component={Link} to="/applications">
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
}

export default ActionButtons;
ActionButtons.propTypes = {
  handleFormSave: PropTypes.func.isRequired,
  applicationId: PropTypes.string,
};
ActionButtons.defaultProps = {
  applicationId: "",
};
